import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import SoundControl from '../components/SoundControl/SoundControl';
import { persistor } from '../store';
import { initialize } from './appSlice';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
  }, [dispatch]);
};

const App = () => {
  const dispatch = useDispatch();
  const { initialized, initializing, initError } = useSelector(
    state => state.notifications,
  );
  useInitialize(dispatch);
  return useMemo(() => {
    if (initError) {
      return <ErrorPage persistor={persistor} />;
    }

    if (initializing) {
      return <AppLoading />;
    }

    if (initialized) {
      return (
        <AppInnerWrapper>
          <SoundControl />
        </AppInnerWrapper>
      );
    }

    return <ErrorPage persistor={persistor} />;
  }, [initialized, initializing, initError]);
};

export default App;
